import { forwardRef, createElement } from "react";
import { IconProps } from "./types";
import Icon from "../../src/icons/icon";
import { cn } from "../../src/lib/utils";

type IconNodeElement = [
  string,
  {
    key: string;
    children?: IconNodeElement[];
    [key: string]: any;
  },
];

const createLumirIcon = (iconName: string, iconNode: IconNodeElement[]) => {
  const Component = forwardRef<SVGSVGElement, IconProps>(
    ({ className, disabled, onClick, ...props }, ref) =>
      createElement(Icon, {
        ref,
        iconNode,
        className: cn(
          "lumir",
          `lumir-${iconName.toLowerCase()}`,
          "cursor-pointer",
          disabled &&
            "cursor-not-allowed text-semantic-disabled-foreground-global-default",
          className
        ),
        onClick: disabled ? undefined : onClick,
        ...props,
      })
  );

  Component.displayName = `${iconName}Icon`;
  return Component;
};

export default createLumirIcon;
